import type {ForwardedRef, HTMLAttributes} from 'react';
import {forwardRef, useRef} from 'react';
import {useTreeState} from '@react-stately/tree';
import {useMenu} from '@react-aria/menu';
import classNames from 'classnames';
import {mergeRefs} from '@react-aria/utils';
import type {AriaMenuProps} from '@react-types/menu';

import type {SubMenusDict} from './menu.types';
import {MenuSection} from './menu-section';
import styles from './menu.module.css';

type Props = AriaMenuProps<object> &
HTMLAttributes<HTMLUListElement> & {
    className?: string;
    subMenus?: SubMenusDict<object>;
};

export const Menu = forwardRef(
    ({className, subMenus, onAction, onClose, ...props}: Props, passedRef: ForwardedRef<HTMLUListElement>) => {
        const state = useTreeState(props);
        const ownRef = useRef<HTMLUListElement>(null);
        const ref = mergeRefs(passedRef, ownRef);
        const {menuProps} = useMenu(props, state, ownRef);

        return (
            <ul {...menuProps} {...props} className={classNames(styles.root, className)} ref={ref}>
                {[...state.collection].map((item) => (
                    <MenuSection
                        key={item.key}
                        section={item}
                        state={state}
                        onAction={onAction}
                        onClose={onClose}
                        subMenus={subMenus}
                    />
                ))}
            </ul>
        );
    },
);
